module.exports = __webpack_public_path__ + "static/media/etsy.4330ef0c.svg";